import $ from 'jquery';
import 'slick-carousel';
import qsa from '../../scripts/util/dom/qsa';
import addClass from '../../scripts/util/dom/addClass';
import rmc from '../../scripts/util/dom/rmc';
import {forEach} from 'ramda';

export default class SliderMak {
	constructor(options) {
		const defaults = {
			el: '.js-slider-mak',
			dom: {
				slider: '.js-slider-wrap',
				button: '.js-mak-btn',
				video: 'video'
			}
		};

		this.classes = {
			videoPlay: 'slider-mak__slide-item_video_play'
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$slider = $(this.options.dom.slider);
		this.$button = $(this.options.dom.button);
		this.$video = $(this.options.dom.video);
	}

	init() {
		this.$slider.not('.slick-initialized').slick({
			// autoplay: true,
			dots: true,
			arrows: false,
			adaptiveHeight: true,
			lazyLoad: 'ondemand'
		});
	}

	playVideo = e => {
		e.stopPropagation();
		const target = e.currentTarget;
		const video = target.previousElementSibling;
		const slide = video.parentElement;
		addClass(this.classes.videoPlay, slide);
		video.play();
	}

	stopVideo = video => {
		rmc(this.classes.videoPlay, video.parentNode);
		video.pause();
	};

	pauseVideo = e => {
		const slide = e.currentTarget;
		const video = slide.querySelector('video');
		if (!video.paused) {
			this.stopVideo(video);
		}
	};

	stopVideos = () => forEach(this.stopVideo, qsa('video'));

	render() {
		if (this.$el.length) {
			this.init();
			this.$button.on('click', this.playVideo);
			$('.slider-mak__slide-item_video').on('click', this.pauseVideo);
			this.$slider.on('beforeChange', this.stopVideos);
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/slider-mak/slider-mak.js
 **/